<template>
    <div class="delete">

    </div>
</template>

<script>
export default {
    name: 'delete'
}
</script>

<style>

</style>



// WEBPACK FOOTER //
// src/components/Modelos/Listas/DeleteList.vue